import React from "react";

const BuyPlan = ()=>{
    return (
        <h1>Enter the bank account details</h1>
    )
}

export default BuyPlan;